"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profile = void 0;
exports.profile = {
    profile_title: "Профиль",
    profile_ecoPoints: "Экобаллы",
    profile_authorize: "Авторизоваться",
    profile_authorizeDecription: "Для того чтобы,\n получать и копить\n Экобаллы",
    profile_addGeoObject: "Добавить новый пункт",
    profile_goToSupport: "Написать обращение",
    profile_favorites: "Избранные пункты",
    profile_notifications: "Уведомления",
    profile_share: "Поделиться",
    profile_about: "О проекте",
    profile_faq: "Справка",
    profile_favoritesTitle: "Избранные пункты",
    profile_favoritesEmpty: "Сохраняйте понравившиеся пункты, чтобы быстро находить их местоположение",
    profile_shareText: "Все пункты сдачи вторсырья в одном приложении! ",
    profile_favoritesAdd: "Добавить в избранное",
    profile_favoritesRemove: "Удалить из избранного",
    profile_homeNotSelected: "Регион не выбран",
};
//# sourceMappingURL=profile.js.map